<template>
    <div class="fan-images-corner-txt">
        <div class="fan-images-corner-txt2">
            <div class="hash-heart">
                <div class="hash" v-if="json.hashtag" v-html="json.hashtag"></div>
                <HeartIcon class="heart"/>
            </div>

            <h2 v-if="json.fansTitle" v-html="formatMainLabel(json.fansTitle)"></h2>
            <div class="caption" v-if="json.caption" v-html="json.caption"></div>
            <Link
                v-if="json?.linkout?.url"
                :href="json?.linkout?.url"
                :target="json?.linkout?.target"
                :label="gh.removeTags(json?.linkout?.label)"
                :isButton="true"
            />
        </div>
    </div>
</template>
<script>
import gh from '@/helpers/gh'
import Link from "@/components/pieces/Link";
import HeartIcon from "@/components/svgs/HeartIcon.vue";
export default {
    name: "FanImagesCorner",
    components: {
        HeartIcon,
        Link,
    },
    props: {
        json: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            gh: gh
        }
    },
    computed: {
    },
    methods: {
        formatMainLabel(str) {
            str = str.replace(/\n/g, "XXX");
            return str.split("XXX").map(part => `<div>${part}</div>`).join("");
        },
    }

}
</script>